import { postsDB } from '../../firestoreDB'
import {
  GET_NEXT_AUTHORS,
  REFRESH_AUTHORS_PUBLISHED_AT,
  GET_AUTHOR_DATA_FROM_REFERENCE,
  UPDATE_AUTHORS_PUBLISHED_AT,
  ADD_AUTHOR_REF,
  UPDATE_AUTHOR_REF,
  DELETE_AUTHOR,
  SET_AUTHOR_DATA,
  UPDATE_AUTHORS_DATES,
  RESET_AUTHORS_ACTION,
  MERGE_AUTHOR,
  MERGE_AUTHOR_POST_DATA,
  RESET_AUTHORS
} from '../actions/authorQueries'
import { _ } from 'vue-underscore'
import firebase from 'firebase'
import {addListItem, getIndexForNewItem, getIndexForItem} from '@/helper/helper'
import {docToPostData, docToPostRef} from '@/converters/postConverter'
import {getUserAuthorPostsRefsPage} from '@/helper/paginate'
const getDefaultState = () => ({
  authorRefs: [],
  authorData: [],
  lastAuthorPublishedAt: new Date().getTime() / 1000
})

const state = getDefaultState()

const getters = {

  getAuthorPostsData: state => _.compact(state.authorData),
  getAuthorPostsRefs: state => state.authorRefs,
  getLastAuthorPostsPublishedAt: state => state.lastAuthorPublishedAt
}

const actions = {
  [GET_NEXT_AUTHORS]: ({ getters, dispatch, commit }, author) => {
    return new Promise((resolve) => {
      const last = _.last(getters.getAuthorPostsRefs)
      const source = getUserAuthorPostsRefsPage(last && last.score, author)
      source.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        snapshot.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let authorPostRef = null
          switch (docChanged.type) {
            case 'added':
              authorPostRef = docToPostRef(doc)
              commit(ADD_AUTHOR_REF, authorPostRef)
              dispatch(GET_AUTHOR_DATA_FROM_REFERENCE, authorPostRef)
              break
            case 'modified':
              authorPostRef = docToPostRef(doc)
              commit(UPDATE_AUTHOR_REF, authorPostRef)
              break
            case 'removed':
              commit(DELETE_AUTHOR, doc.id)
              break
            default:
              break
          }
        })
        resolve(true)
      })
    })
  },
  [GET_AUTHOR_DATA_FROM_REFERENCE]: ({ commit, dispatch, getters }, item) => {
    postsDB
      .where(firebase.firestore.FieldPath.documentId(), '==', item.key)
      .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
        snapshotDoc.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          const postData = docToPostData(doc, item)
          switch (docChanged.type) {
            case 'added':
              commit(SET_AUTHOR_DATA, postData)
              dispatch(UPDATE_AUTHORS_DATES)
              break
            case 'modified':
              commit(SET_AUTHOR_DATA, postData)
              dispatch(UPDATE_AUTHORS_DATES)
              break
            case 'removed':
              commit(DELETE_AUTHOR, doc.id)
              break
            default:
              break
          }
        })
      })
  },
  [UPDATE_AUTHORS_DATES]: ({ commit, getters }) => {
    const twoDaysInSeconds = 172800
    const minute = 60
    const todaySeconds = new Date().getTime() / 1000 // today seconds
    if (todaySeconds - getters.getLastAuthorPostsPublishedAt > minute) {
      getters.getAuthorPostsData.map((item, index) => {
        if (item) {
          let seconds = item.published_at.seconds
          const diff = todaySeconds - seconds
          if (diff <= twoDaysInSeconds) {
            commit(REFRESH_AUTHORS_PUBLISHED_AT, { item, index })
          } else return true
        }
      })
      commit(UPDATE_AUTHORS_PUBLISHED_AT, todaySeconds)
    }
  },
  [RESET_AUTHORS_ACTION]: ({ commit }) => {
    commit(RESET_AUTHORS)
  },
  [MERGE_AUTHOR]: ({ commit }, value) => {
    commit(MERGE_AUTHOR_POST_DATA, value)
  }
}

const mutations = {
  [ADD_AUTHOR_REF]: (state, elemRef) => {
    const newIndexRef = getIndexForNewItem(state.authorRefs, 'score', elemRef.score)
    state.authorRefs.splice(newIndexRef, 0, elemRef)
    state.authorData.splice(newIndexRef, 0, null)
  },
  [UPDATE_AUTHOR_REF]: (state, elemRef) => {
    const oldIndexRef = getIndexForItem(state.authorRefs, 'key', elemRef.key)
    const oldElemeRef = state.authorRefs[oldIndexRef]
    let elemData = null
    let newIndexRef = -1
    let hasIndexChanged = oldElemeRef.score !== elemRef.score
    if (hasIndexChanged) {
      newIndexRef = getIndexForNewItem(state.authorRefs, 'score', elemRef.score)
      hasIndexChanged = newIndexRef !== oldIndexRef
    }
    if (hasIndexChanged) {
      state.authorRefs.splice(oldIndexRef, 1)
      let elemDataList = state.authorData.splice(oldIndexRef, 1)
      elemData = elemDataList[0] || null
      newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef // Testear
      state.authorRefs = addListItem([...state.authorRefs], elemRef, newIndexRef)
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      state.authorData = addListItem([...state.authorData], elemData, newIndexRef)
    } else {
      state.authorRefs[oldIndexRef] = elemRef
      let authorData = state.authorData
      elemData = authorData[oldIndexRef]
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      authorData[oldIndexRef] = elemData
      state.authorData = [...authorData]
    }
  },
  [SET_AUTHOR_DATA]: (state, elemData) => {
    const index = getIndexForItem(state.authorRefs, 'key', elemData.key)
    if (index > -1) {
      let authorData = [...state.authorData]
      authorData[index] = elemData
      state.authorData = authorData
    }
  },
  [MERGE_AUTHOR_POST_DATA]: (state, value) => {
    const { key, data } = value
    let postElement = _.findWhere(state.authorData, { key: key })
    if (_.size(postElement) > 0) {
      postElement.like = data.like
      state.authorData[postElement.index] = postElement
    }
  },
  [REFRESH_AUTHORS_PUBLISHED_AT]: (state, { item, index }) => {
    state.authorData[index] = {...state.authorData[index],
      published_at: item.published_at,
      moment: Math.random()
    }
  },
  [UPDATE_AUTHORS_PUBLISHED_AT]: (state, dateTimeSeconds) => {
    state.lastFavPublishedAt = dateTimeSeconds
  },
  [DELETE_AUTHOR]: (state, key) => {
    const postIndex = getIndexForItem(state.authorRefs, 'key', key)
    if (postIndex > -1) {
      state.authorRefs.splice(postIndex, 1)
      state.authorData.splice(postIndex, 1)
    }
  },
  [RESET_AUTHORS]: state => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/authorQuery.js